export const reportViewToggleGroupSx = {
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  p: "4px",
  borderRadius: "999px",
  backgroundColor: "#f3f6fa",
  border: "1px solid #dce4ef",
  boxShadow: "inset 0 1px 2px rgba(15, 23, 42, 0.06)",
  "& .MuiToggleButtonGroup-grouped": {
    border: 0,
    m: 0,
    borderRadius: "999px !important",
    "&:not(:first-of-type)": {
      borderLeft: 0,
    },
  },
};

export const reportViewToggleButtonSx = {
  minHeight: 34,
  px: 2,
  py: 0.75,
  color: "#4b5563",
  fontSize: "0.875rem",
  fontWeight: 600,
  lineHeight: 1.2,
  textTransform: "none",
  transition:
    "background-color 160ms ease, color 160ms ease, box-shadow 160ms ease",
  "&:hover": {
    backgroundColor: "#e8eef7",
    color: "#111827",
  },
  "&.Mui-selected": {
    backgroundColor: "#fff",
    color: "#0b63ce",
    boxShadow: "0 2px 8px rgba(15, 23, 42, 0.14)",
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
  "&.Mui-focusVisible": {
    outline: "2px solid rgba(11, 99, 206, 0.32)",
    outlineOffset: "2px",
  },
};

// Secondary (sub) segmented control — same family as the primary pill group
// above, one size step down, so a control nested under a primary tab (e.g.
// the day/month/year breakdown under "Sales Performance") reads as a child
// of it rather than a second, equally-weighted row of tabs.
export const reportViewSubToggleGroupSx = {
  ...reportViewToggleGroupSx,
  p: "3px",
  backgroundColor: "#eef2f7",
};

export const reportViewSubToggleButtonSx = {
  ...reportViewToggleButtonSx,
  minHeight: 28,
  px: 1.5,
  py: 0.5,
  fontSize: "0.8125rem",
  "&.Mui-selected": {
    backgroundColor: "#fff",
    color: "#0b63ce",
    boxShadow: "0 1px 4px rgba(15, 23, 42, 0.12)",
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
};
